import React from "react";
import PropTypes from "prop-types";
import HourlyDropdown from "common/HourlyDropdown";
import Icon from "SF/MaterialIcon";
import css from "./VirtualCheckInDayRow.scss";
import {isEmpty} from "lodash";
import classnames from "classnames";
import {fifteenMinuteIntervalSlotsForDay} from "utils/time";
import {SFVirtualCheckInModifySchedule} from "utils/types";

const VirtualCheckInTimeSlot = ({rowId, slot, idx, modifyCheckInSchedule,  abbreviatedTZ}) => {
    const availableTimeSlotOptions = fifteenMinuteIntervalSlotsForDay(abbreviatedTZ);

    // Relevant options in the dropdown [filterDropdown] depending on the time already selected in the other dropdown [selectedSlotTime].
    // Example: If selectedSlotTime is 9:00 am and filterDropdown is 'closeTime' dropdown,
    // this will return all quarterly hour of the days after 9am as options for the open time dropdown viz 9:15 am, 9:30 am, 9:45 am ..etc
    const filteredQuarterlyHoursOptions = (selectedSlotTime, filterDropdown) => {
        if (isEmpty(selectedSlotTime)) return availableTimeSlotOptions;
        const selectedSlotTimeIndex = availableTimeSlotOptions.findIndex(({value}) => value === selectedSlotTime)
        if (selectedSlotTimeIndex === 0) return availableTimeSlotOptions;
        return availableTimeSlotOptions.filter((_, index) =>
            (filterDropdown === "openTime" ? index < selectedSlotTimeIndex : index > selectedSlotTimeIndex) || index === 0)
    }

    const filterByLabel = (option, input) => {
        return option.label.includes(input);
    }

    const openTimeDropdown = () =>
         <label className={css['label-text']}>
            <span>Open Time</span>
            <HourlyDropdown id={`open-time-${rowId}${idx}`}
                            ariaLabel="Select open time"
                            options={filteredQuarterlyHoursOptions(slot.closeTime, "openTime")}
                            placeholder="Open Time"
                            filterOption={filterByLabel}
                            className={css['timeSlotDropdown']}
                            onChange={(value) => modifyCheckInSchedule.timeSlotCallBacks.setOpenTime(rowId, idx, value) }
                            value={slot.openTime} />
         </label>;

    const closeTimeDropdown = () =>
        <label className={css['label-text']}>
            <span>Close Time</span>
            <HourlyDropdown id={`close-time-${rowId}${idx}`}
                            ariaLabel="Select Close Time"
                            options = {filteredQuarterlyHoursOptions(slot.openTime, "closeTime")}
                            placeholder="Close Time"
                            filterOption={filterByLabel}
                            className={css['timeSlotDropdown']}
                            onChange={(value) => modifyCheckInSchedule.timeSlotCallBacks.setCloseTime(rowId, idx, value) }
                            value={slot.closeTime} />
        </label>;

    const duplicateDayOption = () =>
        <button className={css['tools']} onClick={() => modifyCheckInSchedule.copyDayRow(rowId)} aria-label="Duplicate Day & Times">
            <Icon icon="content_copy" aria-hidden={true} className={css['slot-icon']}/>
            Duplicate Day & Times
        </button>

    const removeDayOption = () =>
        <button className={css['tools']} onClick={() => modifyCheckInSchedule.removeDayRow(rowId)} aria-label="Remove Day & Times">
            <Icon icon="delete" aria-hidden={true} className={css['slot-icon']}/>
            Remove Day & Times
        </button>

    const removeSlotOption = () =>
        <button className={css['tools']} onClick={() => modifyCheckInSchedule.timeSlotCallBacks.removeTimeSlot(rowId, idx)} aria-label="Remove Time Slot">
            <Icon icon="delete" aria-hidden={true} className={css['slot-icon']}/>
            Remove Slot
        </button>

    return (
        <tr id={"time-slot-" + idx} key={idx} className={css['time-slot']}>
            <td className={css['slot-text']}>From</td>
            <td className={classnames(css['time'], {[css.error]: (!!slot.openTimeError && !!slot.overlapError)})}>
                {openTimeDropdown()}
                {(slot.openTimeError || slot.overlapError)
                && <div className={css['error-message']}><Icon icon="error" aria-hidden="true" />{slot.openTimeError || slot.overlapError}</div>}
            </td>
            <td className={css['slot-text']}>To</td>
            <td className={classnames(css['time'], {[css.error]: (!!slot.closeTimeError && !!slot.overlapError)})}>
                {closeTimeDropdown()}
                {(slot.closeTimeError || slot.overlapError)
                && <div className={css['error-message']}><Icon icon="error" aria-hidden="true" />{slot.closeTimeError || slot.overlapError}</div>}
            </td>
            <td className={css['tools-cell']}>
                <button className={css['tools']} onClick={() => modifyCheckInSchedule.timeSlotCallBacks.addTimeSlot(rowId)} aria-label="Add Time Slot">
                    <Icon icon="add" aria-hidden={true} className={css['slot-icon']}/>
                    Add Time Slot
                </button>
                {idx === 0 && duplicateDayOption()}
                {idx === 0 && removeDayOption()}
                {idx !== 0 && removeSlotOption()}
            </td>
         </tr>
    );
}

VirtualCheckInTimeSlot.propTypes = {
    rowId: PropTypes.number.isRequired,
    slot: PropTypes.object.isRequired,
    idx: PropTypes.number.isRequired,
    abbreviatedTZ: PropTypes.string.isRequired,
    modifyCheckInSchedule: SFVirtualCheckInModifySchedule.isRequired
}

export default VirtualCheckInTimeSlot;
